<mat-tab-group class="cipo" mat-stretch-tabs="false" color="accent" data-testid="document-details-tabs-container">
    <!-- Remove this check after implemented contracts -->
    @if (currentDocument()?.info) {
        @let _info = currentDocument().info;
        <mat-tab [label]="'activity.title' | translate">
            <cipo-activity-tab [entityInstanceId]="entityInstanceId()" />
        </mat-tab>
        @for (relation of currentDocument().relations; track $index) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <span
                        [matBadge]="relation.records"
                        matBadgeColor="accent"
                        matBadgeOverlap="false"
                        class="cipo--text-height--sm p-r-sm">
                        {{ relation.relatedModuleName }}
                    </span>
                </ng-template>
                <ng-template matTabContent>
                    @if (relation.isPayment) {
                        <cipo-progress-payments-tab [entityInstanceId]="entityInstanceId()" />
                    } @else {
                        <cipo-relations-tab class="m-t" [relation]="relation" [entityInstanceId]="entityInstanceId()" />
                    }
                </ng-template>
            </mat-tab>
        }
        @if (_info?.hasPdfMarkups) {
            <mat-tab [label]="currentDocument().info.pdfMarkupName">
                <ng-template matTabContent>
                    <div class="p-t">
                        <cipo-pdf-markup-tab [entityInstanceId]="entityInstanceId()" />
                    </div>
                </ng-template>
            </mat-tab>
        }
        @let signers = currentDocument().signers;
        @if (signers?.length) {
            <mat-tab [label]="'signature.signatures' | translate">
                <ng-template matTabContent>
                    <cipo-signatures-tab [signers]="signers" />
                </ng-template>
            </mat-tab>
        }
        @if (_info?.canViewAccessLog) {
            <mat-tab [label]="'accessLog' | translate">
                <ng-template matTabContent>
                    <cipo-access-log-tab [entityInstanceId]="entityInstanceId()" />
                </ng-template>
            </mat-tab>
        }
    }
</mat-tab-group>
